import {
  ADD_NEW_TAG,
  CHANGE_TYPE_OF_FORM,
  FETCH_TAGS_CAN_BE_ADDED_ASYNC,
  FETCH_TAGS_CAN_BE_REMOVED_ASYNC,
  RESET_TAGS_FORM_VALUES,
  SET_TAGS_CAN_BE_ADDED_PAGE,
  SET_TAGS_CAN_BE_ADDED_SEARCH,
  SET_TAGS_CAN_BE_REMOVED_PAGE,
  SET_TAGS_CAN_BE_REMOVED_SEARCH,
  TAGS_FORM_SUBMIT_ASYNC,
  TO_ADD_TAGS_CHANGE,
  TO_REMOVE_TAGS_CHANGE,
} from './constants'

const formSubmit = () => ({ type: TAGS_FORM_SUBMIT_ASYNC.INITIATE })
const formSubmitCancel = () => ({ type: TAGS_FORM_SUBMIT_ASYNC.CANCEL })
export const formSubmitSuccess = (data) => ({
  type: TAGS_FORM_SUBMIT_ASYNC.SUCCESS,
  payload: { data },
})
export const formSubmitError = (error) => ({
  type: TAGS_FORM_SUBMIT_ASYNC.ERROR,
  error,
})

export const fetchTagsCanBeAdded = () => ({ type: FETCH_TAGS_CAN_BE_ADDED_ASYNC.INITIATE })
const fetchTagsCanBeAddedCancel = () => ({ type: FETCH_TAGS_CAN_BE_ADDED_ASYNC.CANCEL })
export const fetchTagsCanBeAddedSuccess = (data) => ({
  type: FETCH_TAGS_CAN_BE_ADDED_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchTagsCanBeAddedError = (error) => ({
  type: FETCH_TAGS_CAN_BE_ADDED_ASYNC.ERROR,
  error,
})

export const fetchTagsCanBeRemoved = () => ({ type: FETCH_TAGS_CAN_BE_REMOVED_ASYNC.INITIATE })
const fetchTagsCanBeRemovedCancel = () => ({ type: FETCH_TAGS_CAN_BE_REMOVED_ASYNC.CANCEL })
export const fetchTagsCanBeRemovedSuccess = (data) => ({
  type: FETCH_TAGS_CAN_BE_REMOVED_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchTagsCanBeRemovedError = (error) => ({
  type: FETCH_TAGS_CAN_BE_REMOVED_ASYNC.ERROR,
  error,
})

export const setTagsCanBeAddedPage = (page) => ({
  type: SET_TAGS_CAN_BE_ADDED_PAGE,
  payload: { page },
})
export const setTagsCanBeAddedSearch = (search) => ({
  type: SET_TAGS_CAN_BE_ADDED_SEARCH,
  payload: { search },
})
export const setTagsCanBeRemovedPage = (page) => ({
  type: SET_TAGS_CAN_BE_REMOVED_PAGE,
  payload: { page },
})
export const setTagsCanBeRemovedSearch = (search) => ({
  type: SET_TAGS_CAN_BE_REMOVED_SEARCH,
  payload: { search },
})

const toAddTagsChange = (value) => ({
  type: TO_ADD_TAGS_CHANGE,
  payload: { value },
})
const toRemoveTagsChange = (value) => ({
  type: TO_REMOVE_TAGS_CHANGE,
  payload: { value },
})
export const resetTagsFormValues = () => ({
  type: RESET_TAGS_FORM_VALUES,
})
const addNewTag = (value) => ({
  type: ADD_NEW_TAG,
  payload: { value },
})

const changeTypeOfForm = () => ({ type: CHANGE_TYPE_OF_FORM })

export default {
  formSubmit,
  formSubmitCancel,
  fetchTagsCanBeAdded,
  fetchTagsCanBeAddedError,
  fetchTagsCanBeAddedSuccess,
  fetchTagsCanBeAddedCancel,
  fetchTagsCanBeRemoved,
  fetchTagsCanBeRemovedError,
  fetchTagsCanBeRemovedSuccess,
  fetchTagsCanBeRemovedCancel,
  setTagsCanBeAddedPage,
  setTagsCanBeAddedSearch,
  setTagsCanBeRemovedPage,
  setTagsCanBeRemovedSearch,
  toAddTagsChange,
  toRemoveTagsChange,
  resetTagsFormValues,
  changeTypeOfForm,
  addNewTag,
}
